import Reservations from './Reservations'
import SectionHeading from './SectionHeading'

export default {
  name: 'ReservationsPage',
  components: { Reservations, SectionHeading },
  template: `
<div class="bookings container section-margin-bottom">
  <Reservations
    :active="active"
    :limit="limit"
    :loyaltyId="loyaltyId"
    :properties="properties"
    @error="e => $emit('error', e)" />
</div>`,
  emits: ['error'],
  props: {
    active: Boolean,
    limit: Number,
    loyaltyId: Number,
    properties: Array,
  },
}
